import { useQuery } from '@apollo/client';
import { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import InputField from '../../../components/layout/InputField';
import { customSelectDropDown } from '../../../components/styled/customSelect';
import {
  CompanySize,
  CompanySource,
  COMPANY_STATUS,
  reactQuillReg,
  ROLES,
  URL_REGEX,
} from '../../../utils/constant';
import { FETCH_INDUSTRIES } from '../gql';

import '../../company/company.scss';
import { AppContext } from '../../../context';
import { Controller } from 'react-hook-form';
import ReactQuill from 'react-quill';
import { countSummaryWords } from '../../../utils/helper';

const BasicInfo = ({
  register,
  errors,
  unregister,
  value,
  setValue,
  getValues,
  control,
  ...props
}: any) => {
  const { theme } = useContext(AppContext);
  const [isSelectToggle, setIsSelectToggle] = useState<boolean>(false);
  const { data: industries } = useQuery(FETCH_INDUSTRIES);
  const { userRoles } = useContext(AppContext);
  const [status, setStatus] = useState(props?.companyStatus);
  const [hasCarerPage, setHasCarerPage] = useState(props?.hasCareerPageURL);
  const [hasCompanyURL, setHasCompanyURL] = useState(props?.hasCompanyURL);
  const [nonSolicit, setNonSolicit] = useState<boolean>(false)
  const [isTestCompany, setIsTestCompany] = useState<boolean>(
    props?.isTestCompanyStatus || false
  );

  useEffect(() => {
    setIsTestCompany(props?.isTestCompanyStatus || false);
  }, [props?.isTestCompanyStatus]);

  const industriesList = industries?.allIndustries?.length
    ? industries?.allIndustries?.map((item) => ({
      label: item.name,
      value: item.name,
    }))
    : [];

  const customStyles = {
    control: (styles, provided) => ({
      ...styles,

      fontSize: 12,
    }),

    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
    }),

    container: (provided, state) => ({
      ...provided,
      fontSize: 12,
    }),
  };

  return (
    <div
      className="user-basic-form"
      onClick={() => {
        if (isSelectToggle) {
          setIsSelectToggle(!isSelectToggle);
        }
      }}
    >
      <Row>
        <Col xl="3" lg="4" md="6" sm="12">
          <InputField
            inputtype="text"
            isRequired={true}
            label="Name"
            inputid="name"
            placeholder="Name"
            maxLength={50}
            {...register('name', {
              required: {
                value: true,
                message: 'Name is required!',
              },
            })}
            errMsg={errors?.name?.message as any}
          />
        </Col>
        <Col xl="3" lg="4" md="6" sm="12">
          <InputField
            inputtype="text"
            label="Corporate Phone"
            inputid="phoneNumber"
            placeholder="Corporate Phone"
            {...register('phoneNumber', {
              required: {
                value: false,
                message: 'Corporate phone is required',
              },
            })}
            errMsg={errors?.phoneNumber?.message as any}
          />
        </Col>

        <Col xl="3" lg="4" md="6" sm="12">
          <InputField
            inputtype="text"
            label="Fax"
            inputid="faxNumber"
            placeholder="Fax"
            {...register('faxNumber', {
              required: {
                value: false,
                message: 'Faxis is required!',
              },
            })}
            errMsg={errors?.faxNumber?.message as any}
          />
        </Col>

        <Col xl="3" lg="4" md="6" sm="12">
          <InputField
            inputtype="text"
            isRequired={hasCarerPage ? false : true}
            label="Career Page URL"
            inputid="careerPageURL"
            placeholder="Career Page URL"
            {...register('careerPageURL', {
              required: {
                value: hasCarerPage ? false : true,
                message: 'Career page URL is required!',
              },
              pattern: {
                value: URL_REGEX,
                message: 'Career page URL is not valid!',
              },
            })}
            disabled={hasCarerPage}
          />

          {!hasCarerPage && (
            <small className="text-danger">
              {errors?.careerPageURL?.message as any}
            </small>
          )}

          <FormGroup className="ml-3 mb-1 mt-1 pl-1">
            <Label className="m-0 w-100">
              <Input
                type="checkbox"
                defaultChecked={hasCarerPage}
                {...register('hasCareerPageURL')}
                onChange={(e) => {
                  setValue('careerPageURL', null);
                  setValue('hasCareerPageURL', e.target.checked);
                  setHasCarerPage(e.target.checked);
                }}
                // disabled={hasCarerPage}
                className="mt-1"
              />
              <span className="checkboxTextStyle w-100 pl-lg-0 pl-2">
                Has No Career Page Url
              </span>
            </Label>
          </FormGroup>
        </Col>

        <Col xl="3" lg="4" md="6" sm="12">
          <Label>Industry</Label>
          <Select
            isMulti
            value={props?.selectedIndustry}
            name="industry"
            options={industriesList}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={props.setSelectedIndustry}
            styles={{ ...customSelectDropDown(theme) }}
          />
        </Col>

        <Col xl="3" lg="4" md="6" sm="12">
          <InputField
            label="Company Size"
            inputtype="select"
            selectItems={CompanySize}
            inputid="size"
            placeholder="Company Size"
            {...register('size', { required: false })}
          />
        </Col>

        <Col xl="3" lg="4" md="6" sm="12">
          {userRoles && userRoles.length && userRoles.includes(ROLES.ADMIN) ? (
            <InputField
              label="Status"
              inputtype="select"
              selectItems={COMPANY_STATUS}
              inputid="status"
              placeholder="Status"
              {...register('status', { required: false })}
              // inputValue={status}
              inputMethod={
                props?.recordId && !userRoles?.includes('ADMIN')
                  ? () => { }
                  : setStatus
              }
            />
          ) : (
            <InputField
              label="Status"
              inputtype="text"
              inputid="status"
              placeholder="Status"
              {...register('status', { required: false })}
              inputValue={status}
              readOnly
            />
          )}
        </Col>

        {/* <Col xl="3" lg="4" md="6" sm="12">
          <InputField
            inputtype="text"
            label="Company Url"
            inputid="domain"
            isRequired
            placeholder="Company domain"
            inputRef={register({
              required: {
                value: true,
                message: "Company domain is required!",
              },
              pattern: {
                value: URL_REGEX,
                message: "Company domain is not valid!",
              },
            })}
            errMsg={errors?.domain?.message}
          />
        </Col> */}
        <Col xl="3" lg="4" md="6" sm="12">
          <InputField
            inputtype="text"
            isRequired={hasCompanyURL ? false : true}
            label="Company Url"
            inputid="domain"
            placeholder="Company domain"
            {...register('domain', {
              required: {
                value: hasCompanyURL ? false : true,
                message: 'Company domain is required!',
              },
              pattern: {
                value: URL_REGEX,
                message: 'Career page URL is not valid!',
              },
            })}
            disabled={hasCompanyURL}
          />

          {!hasCompanyURL && (
            <small className="text-danger">{errors?.domain?.message as any}</small>
          )}

          <FormGroup className="ml-3 mb-1 mt-1 pl-1">
            <Label className="m-0 w-100">
              <Input
                type="checkbox"
                defaultChecked={hasCompanyURL}
                {...register('hasCompanyURL')}
                onChange={(e) => {
                  setValue('domain', null);
                  setValue('hasCompanyURL', e.target.checked);
                  setHasCompanyURL(e.target.checked);
                }}
                // disabled={hasCarerPage}
                className="mt-1"
              />
              <span className="checkboxTextStyle w-100 pl-lg-0 pl-2">
                Has No Company Url
              </span>
            </Label>
          </FormGroup>
        </Col>

        <Col xl="3" lg="4" md="6" sm="12">
          <InputField
            inputtype="text"
            label="Bill Box Tag"
            inputid="billBoxTag"
            placeholder="Bill Box Tag"
            {...register('billBoxTag')}
            errMsg={errors?.billBoxTag?.message as any}
          />
        </Col>

        {props.onAiRecruiterToggle &&
          (userRoles?.includes('ADMIN') || userRoles?.includes('EXECUTIVE')) && (
            <Col xl="3" lg="4" md="6" sm="12">
              <FormGroup>
                <div className="form-group-heading">
                  <Label>AI Recruiter</Label>
                </div>
                <label className="switch m-0">
                  <Input
                    type="checkbox"
                    checked={props.aiRecruiterEnabled === true}
                    disabled={props.aiRecruiterLoading}
                    onChange={(e) => props.onAiRecruiterToggle(e.target.checked)}
                  />
                  <span className="slider"></span>
                </label>
              </FormGroup>
            </Col>
          )}
        {props?.recordId && (
          <>
            <Col md="12">
              <FormGroup>
                <Label>Company Culture</Label>
                <Controller
                  control={control}
                  name="culture"
                  // rules={{ required: "Content is required!" }}
                  defaultValue={''}
                  render={({ field: { onChange, ref, value = '' } }) => (
                    <div className="editor-height">
                      <ReactQuill
                        onChange={(val) => {
                          if (reactQuillReg.test(val)) {
                            onChange('');
                          } else {
                            onChange(val);
                          }
                        }}
                        value={value}
                        ref={ref}
                      />
                    </div>
                  )}
                />
                <small className="text-danger pt-2">
                  {errors?.culture?.message as any}
                </small>
              </FormGroup>
            </Col>

            <Col md="12">
              <FormGroup>
                <Label>
                  Company Summary <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="summary"
                  // rules={{
                  //   required: false,
                  //   minLength: {
                  //     value: 10,
                  //     message: "Minimum 10 words required!",
                  //   },
                  // }}
                  defaultValue={''}
                  render={({ field: { onChange, ref, value = '' } }) => (
                    <div className="editor-height">
                      <ReactQuill
                        onChange={(val: any) => {
                          if (reactQuillReg.test(val)) {
                            onChange('');
                            props?.setSummaryErr('Summary field is required!');
                          } else {
                            onChange(val);
                            if (countSummaryWords(val) >= 10) {
                              props?.setSummaryErr('');
                            }
                            if (countSummaryWords(val) < 10) {
                              props?.setSummaryErr(
                                'Summary must has at least 10 words!'
                              );
                              return;
                            }
                          }
                        }}
                        value={value}
                        ref={ref}
                      />
                    </div>
                  )}
                />
                <small className="text-danger">{props?.summaryErr}</small>
              </FormGroup>
            </Col>
          </>
        )}
        <Col xl="3" lg="4" md="6" sm="12">
          {/* {props?.recordId ? (
            <>
              <InputField
                inputtype="text"
                label="Source"
                isRequired={true}
                inputid="source"
                value={props?.companySource}
                placeholder="Source"
                readOnly={true}
              />
              <div className="error">{errors?.source?.message}</div>
            </>
          ) : ( */}

          {!props?.recordId && (
            <InputField
              label="Source"
              isRequired={true}
              inputtype="select"
              selectItems={CompanySource}
              inputid="source"
              placeholder="Source"
              inputValue={props?.companySource}
              {...register('source', {
                required: { value: true, message: 'Source is required!' },
              })}
              readOnly={props?.recordId ? true : false}
              errMsg={errors?.source?.message as any}
            />
          )}

          {/* )} */}
        </Col>

        <Col xl="3" lg="4" md="6" sm="12">
          {!props?.recordId && (
            <FormGroup>
              <Label>
                Source Note <span className="text-danger">*</span>
              </Label>
              <input
                {...register('sourceNote', {
                  required: {
                    value: true,
                    message: 'Source note is required!',
                  },
                })}
                placeholder="Source Note..."
                // rows={2}
                className="form-control"
                readOnly={props?.recordId ? true : false}
              />
              <div className="error">{errors?.sourceNote?.message as any}</div>
            </FormGroup>
          )}
        </Col>

        {!props?.recordId &&
          <Col lg="4" sm="12" xs="12">
            <FormGroup>
              <Label for="preferredContact">Non-Solicit</Label>
              <div className="d-flex items-center" style={{ marginTop: '5px' }}>
                <Label className="radio-container">
                  Non-Solicit
                  <input
                    type="checkbox"
                    checked={nonSolicit}
                    {...register('nonSolicit')}
                    onChange={(e) => {
                      setNonSolicit(e.target.checked);
                    }}
                  //       className="mt-1"
                  />
                  <span className="checkmark"></span>
                </Label>
              </div>
            </FormGroup>
          </Col>
        }

        {/* kan-115: Admin/Executive only. When hidden the field is never
            registered, so isTestCompany stays undefined and is not sent. */}
        {props?.recordId &&
          (userRoles?.includes(ROLES.ADMIN) || userRoles?.includes(ROLES.EXECUTIVE)) &&
          <Col lg="4" sm="12" xs="12">
            <FormGroup>
              <Label for="isTestCompany">Test Company</Label>
              <div className="d-flex items-center" style={{ marginTop: '5px' }}>
                <Label className="radio-container">
                  Test company (placements here may use test users)
                  <input
                    type="checkbox"
                    checked={isTestCompany}
                    {...register('isTestCompany', {
                      onChange: (e) => {
                        setIsTestCompany(e.target.checked);
                      }
                    })}
                  />
                  <span className="checkmark"></span>
                </Label>
              </div>
            </FormGroup>
          </Col>
        }
      </Row>
    </div>
  );
};

export default BasicInfo;
